import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import {
  getCandidateProfileImages,
  getCandidateSearch,
  // getCandidatesRecentSubmissions,
  ICandidate,
  ICandidateRecentConversation,
  IJobCandidateInteraction,
} from 'wisestep-api';

// import { failed } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { paginationSettingsStore } from '../../../../utils/PaginationSettingStore';
import { useConversationWidgetStore } from '../../../../utils/useConversationWidgetStore';

interface ITalentPoolSearch {
  list: (ICandidate & { isSelected: boolean })[];
  totalCandidates: number;
  stageStatus: ICandidateRecentConversation[];
  isError: boolean;
}

const useTalentPoolSearch = (
  query: IJobCandidateInteraction,
  buildFullResultSet: boolean,
  setLoader: Dispatch<SetStateAction<boolean>>
): ITalentPoolSearch => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const setSearchQuery = useConversationWidgetStore((state) => state.setSearchQuery);
  const paginationData = paginationSettingsStore((state) => state.getPaginationSettings);
  const paginationSettings = paginationData();
  query.size = Number(paginationSettings?.talentBenchPagination ?? 20);
  const [state, setState] = useState<ITalentPoolSearch>({
    list: [],
    totalCandidates: 0,
    stageStatus: [],
    isError: false,
  });
  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        setLoader(true);
        const response = await getCandidateSearch({ ...query }, buildFullResultSet);
        setSearchQuery(query.query ?? '');
        const candidates = response?.data;
        let enrichedCandidates = candidates;

        if (candidates.length > 0) {
          const profileImagesMap = await getCandidatePorfileMap(
            candidates.map((candidate) => candidate.id)
          );

          enrichedCandidates = candidates.map((candidate) => ({
            ...candidate,
            profileImage: profileImagesMap[candidate.id] ?? null,
          }));
        }
        setState((prev) => ({
          ...prev,
          totalCandidates: Number(response.headers['x-total-count'] ?? 0),
          list: enrichedCandidates,
          isError: false,
        }));
      } catch (e) {
        console.error(e);
        setState((m) => ({ ...m, list: [], totalCandidates: 0, isError: true }));
      } finally {
        setLoader(false);
      }
    };

    fetchCandidates();
  }, [query, buildFullResultSet, setLoader, setNotification, setSearchQuery]);
  return state;
};

export default useTalentPoolSearch;

export const getCandidatePorfileMap = async (candidateIds: string[]) => {
  const profileImagesResponse = await getCandidateProfileImages(candidateIds);
  return (profileImagesResponse?.data ?? []).reduce((acc, { candidateId, profileImage }) => {
    acc[candidateId] = profileImage;
    return acc;
  }, {} as Record<string, string | null>);
};
